var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenInNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    fill: "#7CBE7B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6V7.33333H15.7267L9.17333 13.8867L10.1133 14.8267L16.6667 8.27333V10.6667H18V6H13.3333ZM16.6667 16.6667H7.33333V7.33333H12V6H7.33333C6.97971 6 6.64057 6.14048 6.39052 6.39052C6.14048 6.64057 6 6.97971 6 7.33333V16.6667C6 17.0203 6.14048 17.3594 6.39052 17.6095C6.64057 17.8595 6.97971 18 7.33333 18H16.6667C17.0203 18 17.3594 17.8595 17.6095 17.6095C17.8595 17.3594 18 17.0203 18 16.6667V12H16.6667V16.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNew);
export default __webpack_public_path__ + "static/media/open-in-new.50472715d4d32ac8c9cbce7e8dad29c2.svg";
export { ForwardRef as ReactComponent };